<button mat-flat-button [color]="color" class="{{ btnClass }} disabled:opacity-75 rounded" [type]="type"
    [disabled]="loading || formValid" [ngClass]="{ loading: loading}"
    [ngClass]="{ loading: loading,'pointer-events-none' : btnDisabled, 'bg-red-500': ((color == 'warn' && loading) || color == 'warn') }">
    <span *ngIf="!loading" class="flex items-center justify-center text-custom">
        <ng-content></ng-content>
    </span>
    <span *ngIf="loading" class="flex items-center justify-center">

        <i class="bx bx-loader bx-spin text-[16px] align-middle mr-2"
            [ngClass]="[loading?'!text-custom opacity-100':'', color=='warn' ? 'text-white': '!text-white' ]"></i>
        <span [class.text-custom]="loading" [ngClass]="color=='warn' ? 'text-white': '!text-white'">{{ loadingText }}
        </span>
    </span>
</button>
